import { usuarioOutput } from "config/types/usuario";

export const checkPermission = (permisosUsuario: usuarioOutput[], permissionName: string) => {
	return permisosUsuario.some((permiso) => permiso.cargo_funcion.toLocaleLowerCase() === permissionName);
};
